export enum GridPagination {
  Inner = 'inner',
  None = 'none',
  Outer = 'outer',
}
